import appForm from '../mixins/appForm';

export default {
    mixins: [appForm],
    data: () => ({
        error: false,
    }),
    render() {
        return this.$scopedSlots.default({
            ...this.baseRenderProps,
            error: this.error,
            onSubmit: this.onSubmit,
        });
    },
    methods: {
        async onSubmit(evt) {
            evt.preventDefault();

            const { formEl: form } = this.$options;

            const data = await this.mailchimpSubscribe({
                email: form.email.value,
            });

            this.updateSuccesHeight();

            if (data.success) {
                this.success = true;
            } else {
                this.error = data.message;
            }
        },
    },
};
